import { render, staticRenderFns } from "./TriggeredNotification.vue?vue&type=template&id=4b2d68f8&scoped=true"
import script from "./TriggeredNotification.vue?vue&type=script&lang=js"
export * from "./TriggeredNotification.vue?vue&type=script&lang=js"
import style0 from "./TriggeredNotification.vue?vue&type=style&index=0&id=4b2d68f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2d68f8",
  null
  
)

export default component.exports